// extracted by mini-css-extract-plugin
module.exports = {"layout":"main_layout__2x-zk","fit":"main_fit__2Ynda"};